module.exports = __webpack_public_path__ + "img/lvs.33c770ce.png";